
let youtubeTriggers = document.querySelectorAll('.product-video-trigger.youtube');
if (youtubeTriggers.length > 0) {
  youtubeTriggers.forEach(btn => {
    btn.addEventListener('click', (e) => {
      triggerYouTubeModal(e);
    });
  });
}

let modalCloseBtn = document.querySelectorAll('.video-popup .popup__close');
if (modalCloseBtn.length > 0) {
  modalCloseBtn.forEach(btn => {
    btn.addEventListener('click', closeModal);
  });
}

let modalBackground = document.querySelectorAll('.video-popup .popup-bg');
if (modalBackground.length > 0) {
  modalBackground.forEach(bg => {
    bg.addEventListener('click', closeModal);
  });
}

document.body.addEventListener("keyup", function (e) {
  var currentLightbox = document.querySelectorAll('.video-popup');
  if (e.key == "Escape" && currentLightbox.length > 0) {
    currentLightbox.forEach(lightbox => {
      lightbox.style.opacity = 0;
      lightbox.style.visibility = 'hidden';
    });
  }
});

function triggerYouTubeModal(e) {
  // Display
  let videoHolderDiv = e.currentTarget.nextElementSibling;
  videoHolderDiv.style.opacity = 1;
  videoHolderDiv.style.visibility = 'visible';

  // Make YT iframe
  makeVideoIframe(videoHolderDiv.querySelector('.popup-content'));

  // Init YT iframe
  let video = videoHolderDiv.querySelector("iframe");
  initializeYTPlayer(video);
  setTimeout(() => {
    videoPlayer(video, "playVideo");
  }, 800);
}

function closeModal(e) {
  let videoHolderDiv = e.currentTarget.closest(".video-popup");
  videoHolderDiv.style.opacity = 0;
  videoHolderDiv.style.visibility = 'hidden';
  
  let video = videoHolderDiv.querySelector('iframe');
  videoPlayer(video, "pauseVideo");
  video.remove();
}

function initializeYTPlayer (iframe) {
  let player;
  window.onYouTubeIframeAPIReady = function () {
      player = new YT.Player(iframe, {
          events: { }
      });
  }
}

function videoPlayer(iframe, func, args) {
  if (iframe) {
    // Frame exists, 
    iframe.contentWindow.postMessage(JSON.stringify({
      "event": "command",
      "func": func,
      "args": args || [],
    }), "*");
  }
}

function makeVideoIframe (container) {
    let videoSrc = container.getAttribute('data-video-src');
    let iframe = document.createElement('iframe');
    iframe.id = "player";
    iframe.src = videoSrc;
    iframe.allow = "accelerometer; autoplay; encrypted-media; gyroscope";
    iframe.allowFullscreen = true;

    container.append(iframe);
}